import React, { createContext, useContext, useState } from 'react';

// 1. Context 생성
const DocumentViewerContext = createContext();

// 2. Context 사용을 위한 커스텀 Hook
export const useDocumentViewer = () => {
    const context = useContext(DocumentViewerContext);
    
    if (!context) {
        throw new Error('useDocumentViewer must be used within DocumentViewerProvider');
    }
    
    return context;
};

// 3. Provider 컴포넌트
export const DocumentViewerProvider = ({ children }) => {
    // 상태 정의
    const [isOpenRightSideBar, setIsOpenRightSideBar] = useState(false);
    const [documentList, setDocumentList] = useState([]);                // 현재 문서 목록
    const [currentDocumentIndex, setCurrentDocumentIndex] = useState(0); // 현재 선택된 문서의 인덱스

    // 파생 상태는 계산으로 처리
    const currentDocument = documentList[currentDocumentIndex] || null;

    // 메서드 정의
    const openRightSideBar = (documentList, index = 0) => {
        setDocumentList(documentList);
        setCurrentDocumentIndex(index);
        setIsOpenRightSideBar(true);
    };

    const closeRightSideBar = () => {
        setDocumentList([]);
        setCurrentDocumentIndex(0);
        setIsOpenRightSideBar(false);
    };

    // 드롭다운에서 문서 선택할 때 사용
    const switchDocument = (index) => {
        setCurrentDocumentIndex(index);
    };

    // Context 값 정의
    const value = {
        isOpenRightSideBar,
        documentList,
        currentDocumentIndex,
        currentDocument,
        openRightSideBar,
        closeRightSideBar,
        switchDocument
    };

    return (
        <DocumentViewerContext.Provider value={value}>
            {children}
        </DocumentViewerContext.Provider>
    );
};
